/** @type {string} */
const popoverString = "popover";
export default popoverString;
